<style lang="scss" scoped>
@include component(settings) {
	@include part(header) {
		@include part(steps) {
			margin-top: 20px;
		}
	}
	@include part(row) {
		@include grid;
	}
	@include part(left) {
		@include grid-col(4);
		padding-right: 40px;
	}
	@include part(right) {
		@include grid-col(8);
	}
	@include part(pad-bottom) {
		margin-bottom: 30px;
	}
}
</style>
<template lang="pug">
.settings
	app-header
		.settings__header(slot='header')
			h1 Connect to {{ providerFullName }}
			.settings__header__steps
				el-steps(:active='1', finish-status='success')
					el-step(title='Connect')
					el-step(title='Settings')
					el-step(title='Match')
					el-step(title='Classes')
	settings(ref="settings_form" v-on:Saving="loading = $event" :type="'school'" v-on:Saved="next")
		template(slot="footer")
			.main-panel__footer.text-right
				el-button.mega-action(type='success', :loading='loading', @click='save')
					| {{ loading ? "Saving settings..." : "Next step" }}

</template>
<script>
import Settings from "../includes/Settings";
import gql from "graphql-tag";
export default {
	components: {
		Settings
	},
	data() {
		return {
			loading: false
		};
	},
	methods: {
		save() {
			this.$refs.settings_form.save();
		},
		async next() {
			this.$router.push({ name: "wizard.match" });
		}
	}
};
</script>
